<template>
<DxDataGrid :show-borders="true" :data-source="dataSource" ref="gridComponent">
    <DxPaging :enabled="true" :page-size="10" />
    <DxHeaderFilter :visible="true" />
    <DxSearchPanel :visible="true" :width="250" />
    <DxEditing :allow-adding="false" :allow-updating="false" :allow-deleting="false" />
</DxDataGrid>
</template>

<script setup>
/* eslint-disable */
import { ref, defineProps } from 'vue';
import { DxDataGrid, DxPaging, DxHeaderFilter, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid';
import DataSource from 'devextreme/data/data_source';
const props = defineProps([ 'results' ]);
const gridComponent = ref(null);

const dataSource = new DataSource({
    store: {
        type: 'array',
        data: props.results,
        key: 'id'
    },
    paginate: true,
    pageSize: 10
});

</script>

<style lang="scss">

</style>
